module.exports = __webpack_public_path__ + "img/public/SiteIcons/hostStepIcons/calendar.svg?802538e3";